import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const PADDING = 8

export const Container = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  z-index: 1;
  border-radius: 20px 20px 0 0;
  background: linear-gradient(360deg, #f7f9fc -3.32%, rgba(247, 249, 252, 0.2) 50%),
    url(${require('builder/views/Interview/view/FeedbackView/assets/paywall-bg3.png')}) center/cover
      no-repeat; /* Background image */

  padding: 0px ${PADDING}px 0;
`

export const Header = styled.div`
  flex-shrink: 0;
  padding: 32px ${32 - PADDING}px 0 ${32 - PADDING}px;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 80px;

  ${Media.Tablet`
    padding: 24px ${24 - PADDING}px  0 ${24 - PADDING}px;
    flex-direction: column;
    margin-bottom: 24px;
  `}

  ${Media.Phone`
    padding: 16px ${16 - PADDING}px  0 ${16 - PADDING}px;
    flex-direction: column;
    margin-bottom: 24px;
  `}
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 60%;
  gap: 24px;
`
export const RightContainer = styled.div``

export const Title = styled.div`
  white-space: break-spaces;
  ${Typography.L};
  ${FontWeights.Regular};
  color: ${Colors.Neutral100};
`

export const Title2 = styled.div`
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.Neutral100};
`
